"use client";

import { getCloudinaryUrl } from "@/lib/cloudinary";
import { Banner } from "@/components/sections/Banner";
import { OurSalonsHours } from "@/components/sections/nos-salons-hours/OurSalonsHours";
import { BreadcrumbHomepage } from "@/components/sections/breadcrumb-homepage/BreadcrumbHomepage";
import { FindUsSection } from "@/components/sections/find-us/FindUsSection";
import { SeoSection } from "@/components/sections/SeoSection";
import { OurSalonsImages } from "@/components/sections/nos-salons-images/OurSalonsImages";

const ReservationPage = () => {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col items-center justify-between">
        <Banner title="Reservation" backgroundImage={getCloudinaryUrl("reservation-banner")} />
        <BreadcrumbHomepage />
        <OurSalonsHours showTitle={false} />
        <FindUsSection />
        <OurSalonsImages />
        <SeoSection />
      </main>
    </>
  );
};

export default ReservationPage;
